<template>
	<div id="moneyCount" :class="edit ? 'edit' : '' " @mouseenter="btn =true" @mouseleave="btn = false" @click.stop="enterDel">
		<div v-show="!inputs" class="tdCol">
			<template v-if ="showMoney != 0">
				<template v-if ="parseFloat(showMoney) > 0">
					<span v-for="(item,index) in showMoney.split('')" :key="index" v-if="item != '.' && index != 0 " :class="getClassName(item,index-1)">
						{{item == 0 && index < count ? '' : item}}
					</span>
				</template>
				<template v-else>
					<span v-for="(item,index) in showMoney.split('')" :key="index" v-if="item != '.' && index > 1 " class="error">
						{{item == 0 && index < count ? '' : item}}
					</span>
				</template>
			</template>
			<template v-else>
				<span v-for="(item,index) in 11" :key = "index"  :class="getClassName(item,index)">
					{{ getZero(index) }}
				</span>
			</template>
		</div>
		<textarea class="inputShowNumber" v-model='moneycurrencys' v-show='handlerInput' readonly :style='textareaStyle'>
		</textarea>
		<el-input
			v-model="money" ref="inputMoney" v-show="inputs"
			@blur="blurInput('')" @focus="selectAll"
			@input='handleChangeInput'
			@keyup.exact.187.native="trialBalance"
			@keyup.shift.187.native="filterMoney"
			@keyup.61.native="trialBalance"
			@keyup.32.native="moneyChanges"
			@keydown.enter.native="enterSelect"
			@keyup.native = "filterMoney"
			@change="changesSummary"
			@keydown.tab.native.prevent = "tabChanges"
			></el-input>
	</div>
</template>

<script>
import {currencys} from '@/assets/utils/currencyFormat'
export default {
	props:['edit','num','inputFocus','tip','direction'],
	data(){
		return {
			moneycurrencys: 0,
			btn:false,
			inputs:false,
			handlerInput: false,  // 显示
			selectData:'',
			money:0,
			tMoney:[],
			showMoney:0,
			count:0,
			textareaStyle: {
				fontSize: '30px',
				color: '#333'
			},
      onShift:false, // 是否按住shift
		}
	},
	created(){

	},
	methods:{
		getZero(index) {
			let flag = this.direction === 0?'debitMoney': this.direction === 1?'creditorMoney':''
			if(index === 10 && flag === this.tip) {
				return 0
			}
			return ""
		},
		// 监听输入
		handleChangeInput(val) {
			this.handlerInput = this.inputs;
			if(!Number(val)&&val!='') {
				this.handlerInput = false;
			}else {
				this.$set(this.textareaStyle , 'fontSize' , '30px');
				this.$set(this.textareaStyle , 'color' , '#333');
				if(val) {
					if(val>999999999.99) {
						this.moneycurrencys = currencys(999999999.99);
					}else {
						this.moneycurrencys = currencys(val);
					}
				}else {
					this.handlerInput = false;
				}
			}},
		changesSummary(){//当进行金额修改时
			this.$store.commit('UPDATAVOUCHER',true);
			this.$store.commit('UPDATAVOUCHER_SUPER',false);
		},
		enterDel(){
			let auxli = this.$store.state.loadstatus.auxliaryModal;
			if(auxli){
				this.$message.error('请选择辅助核算！');
				return false;
			};
			if(this.edit){
				return false
			}
			this.inputs = true;
			this.$nextTick(()=>{
				this.$refs.inputMoney.focus();
			});
		},
		blurInput(key){
			const _=this;
			_.handlerInput = false;
			if(key){

			}else{
				_.inputs = false;
			}

      if(/[-+*/]/.test(_.money) && _.money.indexOf('=') === -1){
        // 能计算 并且 没有输入 =
        try {
          _.money = eval(_.money.toString())
        } catch (error) {
          _.money = 0;
          _.$message.warning("计算公式输入错误！")
        }
        _.money = parseFloat(_.money.toFixed(2));
      }else{
			  _.money = parseFloat((parseFloat(_.money.toString().replace(/[^0-9.-]/g,''))).toFixed(2));
      }

			if(!isNaN(_.money) && _.money != 0){
				_.money > 999999999.99 ? _.money = 999999999.99 :_.money = _.money;
				if(_.money >0){
					_.showMoney = (1000000000 + (_.money)).toFixed(2);
				}else{
					_.showMoney = (-1000000000 + (_.money)).toFixed(2);
				}
				_.firstNotZero();
			}else{
				_.money = 0;
				_.showMoney =0;
			}
			_.$emit('on-push-money',_.money);
		},
		firstNotZero(){
			this.count= 0;
			var arrsy = this.showMoney.toString().split('');
			if(parseFloat(this.showMoney) >0){
				var i = 1;
			}else{
				var i = 2;
			}
			for(i;i<arrsy.length;i++){
				if(arrsy[i] != 0){
					this.count = i;
					break;
				}
			}
		},selectAll(e){
			e.target.select();
		},
		getClassName(item,ins){
			let className = '';
			if(ins == 2 || ins == 5){
				className ='green';
			}else if(ins == 8){
				className ='blue';
			}
			return className;
		},// 监听动态 = 进行试算平衡
		trialBalance(){
			//按下等号时 =  进行试算平衡计算
			const _=this;
			_.$store.commit('UPDATEAMONEYEACH',false);
			_.$store.commit('UPDATEAMONEYEACH1',false);
			//_.money = 0;
			//_.inputs = false;
			_.blurInput(true);
			setTimeout(()=>{// 失去焦点后自动改为0 当时算后又被改为0
				_.$emit('on-trial-balance',true);
			},20);
		},
		enterSelect(){
			const _=this;
			if(_.tip == 'creditorMoney'){
				_.$refs.inputMoney.blur();
				_.$emit('on-enter-keyDown',true);
			}else if(_.tip == 'debitMoney'){
				_.$refs.inputMoney.blur();
				_.$emit('on-enter-keyDown',true);
			}
		},
		filterMoney(e){//限制用户只能输入两位小数
			const _=this;
			if(_.money != 0){
				_.money = _.money+'';
				if(_.money.indexOf('.') != -1){
          try {
            if(_.money[_.money.length-1] === '.') return

            const reg = /[-+*/]|[0-9]+(\.[0-9]+)?|(^\.[0-9]+)?/g;
            const symbolNumArr = _.money.match(reg);
            const resultArr = []

            console.log(symbolNumArr,'--->symbolNumArr');
            symbolNumArr.forEach(element=>{
              if(/[-+*/]/g.test(element)){
                // 符号
                resultArr.push(element)
              }else{
                // 数字
                let p = element.split('.')[1]
                const point = element.indexOf('.') + 3
                if(element.indexOf('.') != -1 && p.length >=2){
                  resultArr.push(element.substring(0,point))
                }else{
                  resultArr.push(element)
                }
              }
            })

            console.log(resultArr,'--->resultArr');
            _.money = resultArr.join('')

          } catch (error) {
            _.money = 0;
            _.$message.warning("计算公式输入错误！")
          }
				}
			}
		},//
		moneyChanges(e){ //金额交换
			//按下等号时 =  进行借方贷方金额交换
			const _=this;
			_.blurInput();
			setTimeout(()=>{// 失去焦点后自动改为0 当时算后又被改为0
				_.$emit('on-money-changes',true);
			},20);
		},//tab事件控制
		tabChanges(val){
			const _=this;
			if(val.shiftKey){
				_.$emit('on-tab-focusChange',false);
			}else{
				if(_.tip == 'creditorMoney'){
					_.$refs.inputMoney.blur();
					_.$emit('on-tab-focusChange',true);
				}else if(_.tip == 'debitMoney'){
					_.$refs.inputMoney.blur();
					_.$emit('on-tab-focusChange',true);
				}
			}
		},
	},
	mounted() {
		//设置默认金额时
		const _=this;
		if(this.num > 0){
			this.showMoney = (1000000000 + (this.num)).toFixed(2);
			this.money = this.num;
			this.firstNotZero();
			this.$emit('on-push-money',this.num);
		};
		///全局禁用 空格键
		this.$refs.inputMoney.$el.onkeydown = function(e) {
			//禁用数字键 .- del 以外的所有键盘
			if((e.keyCode >= 48 && e.keyCode<=57) || (e.keyCode >= 96 && e.keyCode<=105) || e.keyCode == 190  || e.keyCode == 110 || e.keyCode == 109  || e.keyCode == 189  || e.keyCode == 8 ||  e.keyCode == 17 || e.keyCode == 67 || e.keyCode == 86 || e.keyCode == 107 || e.keyCode == 106 || e.keyCode == 111 || e.keyCode == 191 || e.keyCode == 16 || e.keyCode == 187) {
				//console.log('可以输入');
				_.$store.commit('UPDATEAMONEYEACH',false);
				_.$store.commit('UPDATEAMONEYEACH1',false);

			}else{
				//console.log('已为您禁用',e.keyCode)
				window.event.returnValue= false;
			}
		}
	},
	watch:{
		//当动态改变金额时
    num:{
      handler(val){
      	if(val === null)  val=0;
        if(val == 0 ){
        	this.showMoney =  0;
        	this.money = val;
        }else if(val < 0){
        	this.money = val.toFixed(2);
        	this.showMoney = '-'+(1000000000 + parseFloat(Math.abs(val))).toFixed(2);
        }else{
        	this.showMoney = (1000000000 + parseFloat(val)).toFixed(2);
        	this.money = val.toFixed(2);
        }
        this.firstNotZero();
        this.$emit('on-push-money',val);
      },
      deep:true,
			immediate:true,
    },
		/* num(val){
      console.log('金额：'+val);
			if(val == 0 ){
				this.showMoney = 0;
				this.money = val;
			}else if(val < 0){
				this.money = val.toFixed(2);
				this.showMoney = '-'+(1000000000 + parseFloat(Math.abs(val))).toFixed(2);
			}else{
				this.showMoney = (1000000000 + parseFloat(val)).toFixed(2);
				this.money = val.toFixed(2);
			}
			this.firstNotZero();
			this.$emit('on-push-money',val);
		}, */
		inputFocus:{
			handler(Val){
				const _=this;
				if(Val && Val.deInputFocus && _.tip == 'debitMoney'){
					_.inputs = true;
					_.$nextTick(() => {
						_.$refs.inputMoney.focus();
					});
				};
				if(Val && Val.crInputFocus && _.tip == 'creditorMoney'){
					_.inputs = true;
					_.$nextTick(() => {
						_.$refs.inputMoney.focus();
					});
				};
			},
			deep:true,
			immediate:true,
		}
	}
}
</script>

<style lang="less">
	#moneyCount{
		height: 100%;
		min-height: 56px;
		width: 100%;
		font-size: 14px;
		font-weight: bold;
		position: relative;
		.inputShowNumber {
			width: 100%;
			height: 56px;
			font-weight: bold;
			font-family: '微软雅黑';
			resize:none;
			position: absolute;
			border-radius: 8px;
			border-color: #999 !important;
			-webkit-box-shadow: 10px 10px 10px #999;
			-moz-box-shadow: 10px 10px 10px #999;
			box-shadow: 10px 10px 10px #999;
			top:-70px;
			left: 15px;
			.inputShowNumber_input {
				width: 100%;
				height: 100%;
			}
		}
		.el-input{
			height: 100%;
			width: 100%;
		}
		.el-input__inner{
			border: none;
			outline: none;
			height: 100%;
			font-size: 16px;
			font-weight: bold;
			ime-mode:disabled
		}
		.tdCol{
			display: table;
			width: 100%;
			height: 100%;
			span{
				display: table-cell;
				width: 9.09090909099%;
				height: 100%;
				border-right: 1px solid #ccc;
				vertical-align: middle;
				line-height: 100%;
				&:last-child{
					border-right: none;
				}
				&.error{
					color: red;
				}
				&.green{
					border-right: solid 1px rgba(255, 220, 220, 1);
				}
				&.blue{
					border-right: solid 1px rgba(186, 229, 255, 1);
				}
			}
		}
		&.edit{
			height: 70px;
			.tdCol{
				span{
					line-height: 70px;
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/table/moneyCount.vue